import script from "./WReportSubmit.vue?vue&type=script&setup=true&lang=ts"
export * from "./WReportSubmit.vue?vue&type=script&setup=true&lang=ts"

import "./WReportSubmit.vue?vue&type=style&index=0&id=2dc7555f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc7555f"]])

export default __exports__